module.exports = __webpack_public_path__ + "static/media/thomas.821e7bea.jpg";